module.exports = __webpack_public_path__ + "static/media/redShield.991710fa.svg";